export const determineInputType = (t: string) => {
  switch (t) {
    case 'text':
    case 'string':
      return 'string'
    case 'float':
    case 'decimal':
    case 'double':
      return 'number'
    default:
      return 'string'
  }
}
